<template>
  <div class="row">
    <div class="col-md-12">
      <wordcloud
        v-if="cloudData.length > 0"
        :data="cloudData"
        nameKey="name"
        valueKey="value"
        :rotate="cloudRotate"
        :showTooltip="false"
      />
    </div>
  </div>
</template>

<script>
import wordcloud from "vue-wordcloud";

export default {
  name: "TotalKeywords",
  components: {
    wordcloud
  },
  props: {
    propCloudData: Array
  },
  data() {
    return {
      cloudData: this.propCloudData,
      cloudRotate: {
        from: 0,
        to: 0,
        numOfOrientation: 0
      }
    };
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/monitoring/summary/components/totalKeywords.vue